// ** React Imports
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'

// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/store'

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { ToastContainer } from 'react-toastify'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'

// ** i18n
import './configs/i18n'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** Fake Database
import './@fake-db'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
// import './@core/scss/core.scss'

if (window.location !== null) {
  const companyID = JSON.parse(localStorage.getItem('companyID'))
  const staffRoleID = JSON.parse(localStorage.getItem('staffRoleID'))
  const search = window.location?.search
  const isDePassApp = search?.includes('DE_PassApp') || (companyID === 10010 && staffRoleID === 'Passenger')
  const isChariot = search?.includes('CharChauf') || companyID === 10005

  if (isChariot) {
    import('./@core/scss/chariot-core.scss').then(() => {
      // console.log('Chariot theme loaded')
    })
  } else if (isDePassApp) {
    import('./@core/scss/de-core.scss').then(() => {
      // console.log('DE_PassApp theme loaded')
    })
  } else {
    import('./@core/scss/core.scss').then(() => {
      // console.log('Core theme loaded')
    })
  }
}

import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))
window.isLoading = false
ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <AbilityContext.Provider value={ability}>
        <ThemeContext>
          <LazyApp />
          <ToastContainer newestOnTop />
        </ThemeContext>
      </AbilityContext.Provider>
    </Suspense>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
